import { StringType } from '@convergence/types';
import { getError } from '../util';
import { actionDataFromTreeAndPath } from './util';
import { ActionInputProps } from './types';
import { StringActionInputSelector } from './type-selectors/string-action-input-selector';

export function AnalysisStringAction(props: ActionInputProps<StringType>) {
  let actionData = actionDataFromTreeAndPath(
    props.tree,
    props.propertyPath
  ) ?? {
    type: 'value',
    value: ''
  };

  const error = getError(props.errors, props.propertyPath);

  return (
    <div className="py-2 flex justify-between items-center border-b border-black">
      <label className="inline-flex items-center">{props.name}</label>
      <StringActionInputSelector
        actionData={actionData}
        setActionData={(data) => {
          props.onChange(props.propertyPath, data);
        }}
      />
      {error && <p className="text-red-600">{error.message}</p>}
    </div>
  );
}
